import { USERS_ACTIVITY_FILTERS_FAILURE, USERS_ACTIVITY_FILTERS_REQUEST, USERS_ACTIVITY_FILTERS_SUCCESS, UsersActivityFiltersActionTypes, UsersActivityFiltersState } from './types';

const defaultState: UsersActivityFiltersState = {
  isLoading: false,
  errorMessage: '',
};

function usersActivityFilters(state = defaultState, action: UsersActivityFiltersActionTypes): UsersActivityFiltersState {
  switch (action.type) {
    case USERS_ACTIVITY_FILTERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case USERS_ACTIVITY_FILTERS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: '',
      };
    case USERS_ACTIVITY_FILTERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: '',
      };
    default:
      return state;
  }
}

export default usersActivityFilters;
